import React from "react";

export const FullScreenLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[var(--brand-bg)]" data-testid="fullscreen-loader">
    <div className="flex flex-col items-center gap-3">
      <div className="w-10 h-10 rounded-full border-2 border-[var(--brand-border)] border-t-[var(--brand-primary)] animate-spin" />
      <div className="text-sm text-[var(--brand-muted)]">Lädt …</div>
    </div>
  </div>
);
